import React, { useState } from 'react'
import { Dropdown } from 'react-bootstrap'

import { KTIcon } from '../../../../../_metronic/helpers'
import { RowKebabMenu } from '../../../../common/RowKebabMenu'
import { ResendCallbackButton } from '../common/ResendCallbackButton'

interface Props {
  ticketToken: string
  canResend: boolean
  canCreateDispute: boolean
  onCreateDispute: () => void
  /** CPAYMENT-1857: спор открыт и момент освобождения выплаты не задан. */
  canReleaseChunk: boolean
  onReleaseChunk: () => void
}

/**
 * Меню действий строки пополнения (CPAYMENT-1615).
 *
 * Действия, которых в строке становится много, собраны под одну «⋮»: строка остаётся читаемой,
 * а редкие операции не занимают место рядом с данными. Кнопки завершения/отмены тикета остаются
 * снаружи — это частые операции очереди.
 *
 * Меню не рендерится вовсе, если ни один пункт недоступен: пустая «⋮» обманывает — обещает
 * действия, которых нет.
 *
 * Меню открывается ВЛЕВО от кнопки (`drop='start'`, дефолт `RowKebabMenu`) с отступом: кнопка
 * стоит у правого края строки, и выпадение вниз перекрывало бы действия соседних строк.
 */
export const ActivePaymentTicketRowMenu: React.FC<Props> = ({
  ticketToken,
  canResend,
  canCreateDispute,
  onCreateDispute,
  canReleaseChunk,
  onReleaseChunk,
}) => {
  const [show, setShow] = useState(false)

  if (!canResend && !canCreateDispute && !canReleaseChunk) {
    return null
  }

  return (
    <RowKebabMenu title='Действия по тикету' show={show} onToggle={setShow}>
      {canCreateDispute && (
        <Dropdown.Item
          as='button'
          type='button'
          className='d-flex align-items-center'
          onClick={onCreateDispute}
        >
          <KTIcon iconName='shield-cross' className='fs-3 me-2' />
          Создать диспут
        </Dropdown.Item>
      )}
      {canReleaseChunk && (
        <Dropdown.Item
          as='button'
          type='button'
          className='d-flex align-items-center'
          onClick={onReleaseChunk}
        >
          <KTIcon iconName='lock-3' className='fs-3 me-2' />
          Освободить депозит
        </Dropdown.Item>
      )}
      {canResend && (
        // ResendCallbackButton гасит всплытие внутри себя, поэтому клик по нему не долетает до
        // штатного автозакрытия меню. Ловим в фазе перехвата — она отрабатывает до обработчика
        // кнопки и на stopPropagation не завязана.
        <div onClickCapture={() => setShow(false)}>
          <ResendCallbackButton
            token={ticketToken}
            className='dropdown-item d-flex align-items-center'
            label='Отправить КБ'
          />
        </div>
      )}
    </RowKebabMenu>
  )
}

export default ActivePaymentTicketRowMenu
